import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { AuthenticationService } from "app/auth/service";
import { UtilsService } from "app/auth/service/utils.service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { IProductCommissionListWithAnalytics } from "app/modules/products/models/prodcuts-commissions";
import { IProductSingle } from "app/modules/products/models/products";
import { IDealProductList } from "app/modules/products/models/products-deals";
import { ProductsCommissionsService } from "app/modules/products/products-commissions.service";
import { ProductsService } from "app/modules/products/products.service";

@Component({
  selector: "app-products-detail",
  templateUrl: "./products-detail.component.html",
  styleUrls: ["./products-detail.component.scss"],
})
export class ProductsDetailComponent implements OnInit {
  public contentHeader: IContentHeader = null;
  public productId: number = null;
  public product: IProductSingle = null;
  public searchKeyDeals: string = "";
  public searchKeyCommission: string = "";
  public tableLimit: number = 10;
  public dealsList: IDealProductList[] = [];
  public filterDeals: IDealProductList[] = [];
  public commissionList: IProductCommissionListWithAnalytics[] = [];
  public filterCommission: IProductCommissionListWithAnalytics[] = [];

  constructor(
    private _activatedRoute: ActivatedRoute,
    public _utilService: UtilsService,
    public _productsService: ProductsService,
    public _authenticationService: AuthenticationService,
    private _router: Router,
    private _productsCommissionsService: ProductsCommissionsService,
  ) {
    this.contentHeader = {
      headerTitle: "MENU.PRODUCTS",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "PRODUCTS",
            isLink: true,
            link: "/dashboard/products/list",
          },
          {
            name: "MENU.PRODUCT_DETAIL",
            isLink: false,
          },
        ],
      },
    };

    this._activatedRoute.paramMap.subscribe(async (params: ParamMap) => {
      const customerId: string = params.get("id");
      if (customerId) {
        this.productId = Number(customerId);
      }
    });
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("detail_product")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    await this.loadProduct();
  }

  async loadProduct() {
    this.product = await this._productsService.getProduct(this.productId);
    if (!this.product) {
      await this._utilService.showToastrError("PRODUCT_NOT_FOUND");
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    } else {
      this.contentHeader.headerTitle = this.product.name;
    }
    if (this.product && this.product.deals && this.product.deals.length > 0) {
      this.dealsList = this.product.deals;
    }
    this.commissionList = await this._productsCommissionsService.getCommissionsListWithAnalytics(this.product.id);
    if (this.commissionList && this.commissionList.length > 0) {
      this.commissionList.map((commission: IProductCommissionListWithAnalytics) => {
        commission.products_names = [];
        if (commission && commission.commission_analytics[0] && commission.commission_analytics[0].employees_analytics && commission.commission_analytics[0].employees_analytics.length > 0) {
          commission.commission_analytics[0].employees_analytics.map((product: { id: number; name: string }) => {
            if (product && product.name) {
              commission.products_names.push(product.name);
            }
          });
        }
      });
    }
    this.searchDeal();
    this.searchDealOrder();
  }

  searchDeal() {
    let filteredArray: IDealProductList[] = this.dealsList;

    if (this.searchKeyDeals && this.searchKeyDeals.length > 0) {
      const key: string = this.searchKeyDeals.toLowerCase();
      filteredArray = filteredArray.filter((product: IDealProductList) => product.complete_name.toLowerCase().includes(key));
    }
    this.filterDeals = filteredArray;
  }

  searchDealOrder() {
    let filteredArray: IProductCommissionListWithAnalytics[] = this.commissionList;

    if (this.searchKeyCommission && this.searchKeyCommission.length > 0) {
      const key: string = this.searchKeyCommission.toLowerCase();
      filteredArray = filteredArray.filter((product: IProductCommissionListWithAnalytics) => product.complete_name.toLowerCase().includes(key));
    }
    this.filterCommission = filteredArray;
  }

  updateTableLimit(event: { target: { value: string } }) {
    this.tableLimit = Number(event.target.value);
  }

  descriptionTooltip(description: string[]): string {
    if (description && description.length > 0) {
      return description.join(", ");
    }
  }
}
